import { call, put, race, take, takeEvery, takeLeading } from "redux-saga/effects"
import * as api from "./api"

// Events Redux States
import {
  GET_CLUBS,
  GET_CLUB_INFO,
  GET_CLUB_OWNER,
  GET_CLUB_ORGANIZERS,
  GET_CLUB_ARCHIVE_INFO,
  GET_CLUB_LOCATIONS,
  REFRESH_CLUBS,
} from "./actionTypes"

import {
  apiError,
  clubsRefreshed,
  getClubsSuccess,
  getClubInfoFailure,
  getClubInfoSuccess,
  getClubOwnerSuccess,
  getClubOrganizersSuccess,
  getClubArchiveInfoSuccess,
  getClubsLocationsSuccess,
} from "./actions"

function* getClubsLocations({ filters }) {
  try {
    const { data } = yield call(api.getClubsLocations, filters)
    yield put(getClubsLocationsSuccess(data))
  } catch (error) {
    yield put(apiError(error))
  }
}

function* getClubs({ filters, options, payload: [] }) {
  try {
    const { data } = yield call(api.getClubs, filters, options)
    yield put(getClubsSuccess(data))
  } catch (error) {
    yield put(apiError(error))
  }
}

// The list read again in the background while its texts translate (ADR 0013), one read at a time: a read that fails, or answers with no
// list, keeps the list, and the next one tries again; one that a newer read of the list overtakes is dropped.
function* refreshClubs({ filters, options }) {
  try {
    const { read } = yield race({ read: call(api.getClubs, filters, options), overtaken: take(GET_CLUBS) })
    if (Array.isArray(read?.data?.results)) yield put(clubsRefreshed(read.data))
  } catch (error) {
    // The list stays as it is.
  }
}

function* getClubInfo({ id }) {
  try {
    const { data } = yield call(api.getClubInfo, id)
    if (!data?.id || String(data.id) !== String(id)) {
      throw new Error("Invalid club profile response")
    }
    yield put(getClubInfoSuccess(data, id))
  } catch (error) {
    yield put(getClubInfoFailure(error, id))
  }
}

function* getClubOwner({ id, clubId }) {
  try {
    const { data } = yield call(api.getClubOwner, id)
    yield put(getClubOwnerSuccess(data, clubId))
  } catch (error) {
    yield put(apiError(error))
  }
}

function* getClubOrganizers({ id }) {
  try {
    const { data } = yield call(api.getClubOrganizers, id)
    yield put(getClubOrganizersSuccess(data, id))
  } catch (error) {
    yield put(apiError(error))
  }
}

function* getClubArchiveInfo({ id }) {
  try {
    const { data } = yield call(api.getClubArchiveInfo, id)
    yield put(getClubArchiveInfoSuccess(data))
  } catch (error) {
    yield put(apiError(error))
  }
}

function* eventsSaga() {
  yield takeEvery(GET_CLUB_LOCATIONS, getClubsLocations)
  yield takeEvery(GET_CLUBS, getClubs)
  yield takeLeading(REFRESH_CLUBS, refreshClubs)
  yield takeEvery(GET_CLUB_INFO, getClubInfo)
  yield takeEvery(GET_CLUB_OWNER, getClubOwner)
  yield takeEvery(GET_CLUB_ORGANIZERS, getClubOrganizers)
  yield takeEvery(GET_CLUB_ARCHIVE_INFO, getClubArchiveInfo)
}

export default eventsSaga
